/* eslint-disable arrow-body-style */
import axios, {AxiosResponse, InternalAxiosRequestConfig} from "axios";
import logger from "@FRAMEWORK/utils/logger";
// import logger from "@FRAMEWORK/utils/logger";
// import publicRuntimeConfig from "@FRAMEWORK/config/public";

const instance = axios.create({
	timeout: 15000,
	validateStatus: status => status < 401,
});

// let isTokenRefreshing = true;
// let refreshSubscribers = [];

// const onTokenRefreshed = accessToken => {
// 	refreshSubscribers.map(callback => callback());
// };

// const addRefreshSubscriber = callback => {
// 	refreshSubscribers.push(callback);
// };

instance.interceptors.request.use(
	(config: InternalAxiosRequestConfig) => {
		// const {baseURL, method, url, data, headers} = config;
		// console.log(url);
		// if (url === "/esntl/api/menu") {
		// 	console.log(`request => ${baseURL}${url}`);
		// }
		// ["production"].indexOf(publicRuntimeConfig.RUNTIME_ENV) === -1 &&
		// logger.info({baseURL, method, url} as any, "FETCH Request");
		// config.headers["request-startTime"] = new Date().getTime();
		return config;
	},
	error => Promise.reject(error),
);

instance.interceptors.response.use(
	async (response: AxiosResponse) => {
		return response;
	},
	async error => {
		let payload: {[key: string]: string} = {};
		if (typeof window !== "undefined") {
			payload.ua = navigator.userAgent;
			payload.referer = location.href;
		}
		try {
			if (error.response) {
				// The request was made and the server responded with a status code
				// that falls out of the range of 2xx
				const {data, status, headers} = error.response;
				if (status === 401) {
					return Promise.reject(error);
				}
				payload = {...payload, config: error.config, data, status, headers};
			} else if (error.request) {
				// The request was made but no response was received
				// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
				// http.ClientRequest in node.js
				const {url, method} = error.config;
				payload = {...payload, url, method, request: error.request, message: "no response was received"};
			} else {
				payload = {...payload, config: error.config, message: error.message};
			}
			logger.error(payload);
		} catch (e) {
			logger.error({...payload, message: "interceptors response error throw", error});
		}
		return Promise.reject(error);
	},
);

export default instance;
